// Shared helpers for the dealer picker on the admin Add / Update Boat Show forms.

export const getDealerLabel = (profile) =>
  profile?.company?.trim() || profile?.name?.trim() || "";

// Options for react-select, keyed by profile_id and sorted by the name shown,
// so a newly added dealer appears where you'd expect alphabetically.
export const getDealerOptions = (profiles = []) =>
  profiles
    .filter((profile) => profile?.profile_id && getDealerLabel(profile))
    .map((profile) => ({
      label: getDealerLabel(profile),
      value: profile.profile_id,
      profile,
    }))
    .sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    );

export const getBrands = (profile) => {
  const brands = [];
  if (profile?.has_skiff) brands.push("Carolina Skiff");
  if (profile?.has_funchaser) brands.push("Fun Chaser");
  if (profile?.has_seachaser) brands.push("Sea Chaser");
  return brands.join("/");
};
